"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCompanyListDto = exports.GetCompaniesDto = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
const constants_1 = require("../../../../../../services/service-lib/src/lib/constants");
class GetCompaniesDto {
    constructor() {
        this.page = constants_1.DEFAULT_VALUES.PAGE;
        this.limit = constants_1.DEFAULT_VALUES.LIMIT;
    }
}
exports.GetCompaniesDto = GetCompaniesDto;
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Page number for pagination.",
        example: constants_1.DEFAULT_VALUES.PAGE,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1, { message: "Page must be atleast 1" }),
    tslib_1.__metadata("design:type", Number)
], GetCompaniesDto.prototype, "page", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Number of records per page(by default limit is 10 records).",
        example: constants_1.DEFAULT_VALUES.LIMIT,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1, { message: "Limit must be atleast 1" }),
    tslib_1.__metadata("design:type", Number)
], GetCompaniesDto.prototype, "limit", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Search term to filter companies",
        example: "companyName:Example",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetCompaniesDto.prototype, "search", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Sort order in the format field:order (e.g., companyName:ASC,createdAt:DESC).",
        example: "companyName:ASC,createdAt:DESC",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetCompaniesDto.prototype, "sort", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Field to search by (e.g., companyName, city).",
        example: "Example",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetCompaniesDto.prototype, "searchBy", void 0);
class GetCompanyListDto {
    constructor() {
        this.page = constants_1.DEFAULT_VALUES.PAGE;
        this.limit = constants_1.DEFAULT_VALUES.LIMIT;
    }
}
exports.GetCompanyListDto = GetCompanyListDto;
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Page number for pagination.",
        example: constants_1.DEFAULT_VALUES.PAGE,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1, { message: "Page must be atleast 1" }),
    tslib_1.__metadata("design:type", Number)
], GetCompanyListDto.prototype, "page", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Number of records per page(by default limit is 10 records).",
        example: constants_1.DEFAULT_VALUES.LIMIT,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1, { message: "Limit must be atleast 1" }),
    tslib_1.__metadata("design:type", Number)
], GetCompanyListDto.prototype, "limit", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Search based on company name.",
        example: "Example",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetCompanyListDto.prototype, "search", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Comma separated company ids to append in response list",
        example: "1,2",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => value
        ? String(value)
            .split(",")
            .map((v) => parseInt(v, 10))
        : undefined),
    tslib_1.__metadata("design:type", Array)
], GetCompanyListDto.prototype, "entityIds", void 0);
